import React from 'react';
import IconMoonOutline from "@Icons/IconMoonOutline";
import Translation from "@Translation/components/Translation";

const OvernightTravelBadge = () => (
    <span className="gb--badge-blue">
        <IconMoonOutline/>
        <Translation translationKey="search_results.after_midnight_arrival"/>
    </span>
);

export default OvernightTravelBadge;